import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FAQS } from "@/lib/data";
import { ArrowRight } from "lucide-react";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-24 bg-messinger-bg overflow-hidden border-b border-white/5">
        <div className="absolute inset-x-0 top-0 h-[50%] bg-gradient-to-b from-messinger-orange/10 to-transparent pointer-events-none" />
        <div className="container-x relative">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-messinger-orange" />
            <span className="text-[11px] tracking-[0.28em] uppercase font-semibold text-messinger-orange">
              FAQ
            </span>
          </div>
          <h1 className="font-heading font-semibold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl text-balance">
            Häufig gestellte Fragen. <br />
            <span className="text-messinger-orange">Klar beantwortet.</span>
          </h1>
        </div>
      </section>

      <section className="bg-messinger-surface py-20 lg:py-28 relative">
        <div className="container-x grid lg:grid-cols-12 gap-12 relative">
          <motion.aside
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-4"
          >
            <div className="lg:sticky lg:top-28 surface-card p-6 lg:p-8 rounded-2xl">
              <div className="label-eyebrow">Noch Fragen offen?</div>
              <h3 className="mt-3 font-heading font-semibold text-white text-2xl leading-tight">
                Sprechen Sie mich an — persönlich.
              </h3>
              <p className="mt-3 text-sm text-white/65 leading-relaxed">
                Was hier nicht steht, klären wir gerne im direkten Gespräch.
                Innerhalb von 24 Stunden erhalten Sie eine persönliche
                Rückmeldung.
              </p>
              <Link
                to="/kontakt"
                data-testid="faq-contact-cta"
                className="cta-orange group mt-6 inline-flex items-center justify-between w-full px-5 py-3 bg-messinger-orange text-white font-semibold rounded-full text-sm"
              >
                Anfrage senden <ArrowRight size={16} />
              </Link>
            </div>
          </motion.aside>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-8"
          >
            <Accordion type="single" collapsible className="space-y-3">
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={item.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border border-white/10 rounded-2xl bg-white/[0.03] backdrop-blur-sm data-[state=open]:border-messinger-orange/60 data-[state=open]:bg-white/[0.05] transition-colors px-6"
                >
                  <AccordionTrigger className="text-left font-heading font-semibold text-white text-base lg:text-lg py-5 hover:no-underline hover:text-messinger-orange [&[data-state=open]>svg]:text-messinger-orange [&>svg]:text-white/60">
                    <span className="flex items-center gap-4">
                      <span className="text-messinger-orange font-bold text-sm tabular-nums">
                        0{i + 1}
                      </span>
                      <span>{item.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-white/70 leading-relaxed text-[15px] pb-6 pl-10">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
